/* page script: gallery (moved from the preview page) */

(function () {
  "use strict";
  var D = AF_DATA, $ = AF.$, $$ = AF.$$, esc = AF.esc, I = AF.icons;
  AF.renderChrome("gallery");
  $$("[data-ig]").forEach(function (e) { e.textContent = D.brand.instagram; });
  $$("[data-social]").forEach(function (e) { e.innerHTML = AF.socialLinks(); });

  var TABS = D.galleryTabs;
  function itemsFor(id) { return D.gallery.filter(function (g) { return g.tab === id; }); }
  function realCount(id) { return itemsFor(id).filter(function (g) { return g.img; }).length + (id === "dyno" ? D.dynoRuns.filter(function (r) { return r.gainPct; }).length : 0); }

  /* tabs */
  $("#gp-tabs").innerHTML = TABS.map(function (t) {
    var n = realCount(t.id);
    return '<button class="af-gp-tab" type="button" role="tab" id="gp-tab-' + t.id + '" aria-controls="gp-' + t.id + '" aria-selected="false" tabindex="-1" data-tab="' + t.id + '">' + esc(t.label) + (n ? "<small>" + n + "</small>" : "") + "</button>";
  }).join("");

  /* one figure */
  function fig(g, i, feature) {
    var media = g.img
      ? '<div class="af-shot' + (g.photo ? " af-shot--photo" : "") + '"><img src="' + g.img + '" alt="' + esc(g.caption) + '" loading="lazy"></div>'
      : AF.ph(g.ph, "4 / 3", g.warm ? "warm" : "", "Photo slot");
    var credit = ("credit" in g) ? (g.credit ? " · Photo: " + esc(g.credit) : " " + AF.confirm("photo credit")) : "";
    return '<button class="af-gp-item' + (feature ? " is-feature" : "") + '" type="button" data-i="' + i + '" aria-label="Open ' + esc(g.caption) + '">' + media +
      '<span class="af-gp-cap"><b>' + esc(g.caption) + "</b>" + credit + (g.img ? "" : "<span>To shoot</span>") + "</span></button>";
  }

  /* panels */
  $("#gp-panels").innerHTML = TABS.map(function (t) {
    var items = itemsFor(t.id), photos = items.filter(function (g) { return g.img; }).length, body = "";
    if (t.id === "dyno") {
      body = '<div id="gp-dyno-chart"></div>' +
        '<div class="af-gp-runs">' + D.dynoRuns.map(function (r) {
          return '<article class="af-gp-run"><p class="af-label" style="margin:0">' + esc(r.sub) + " · " + esc(r.bike) + "</p><h3>" + esc(r.name) + "</h3><dl>" +
            "<dt>Run</dt><dd>" + esc(r.runDate) + " · " + esc(r.dyno) + "</dd>" +
            (r.gainPct ? "<dt>Avg gain</dt><dd>+" + AF.runStats(r).avgPct.toFixed(1) + "% over stock</dd><dt>Avg added</dt><dd>+" + AF.runStats(r).avgHp.toFixed(1) + " HP · +" + AF.runStats(r).avgTq.toFixed(1) + " ft-lb</dd>" +
              "<dt>Up to</dt><dd>+" + AF.runStats(r).upTo.toFixed(1) + " HP at " + AF.runStats(r).upToRpm.toLocaleString("en-CA") + " rpm</dd>"
            : "<dt>Avg</dt><dd>" + AF.runStats(r).avgHpAbs.toFixed(1) + " HP · " + AF.runStats(r).avgTqAbs.toFixed(1) + " ft-lb</dd>") +
            "<dt>Parts</dt><dd>" + (r.parts.length ? r.parts.map(function (id) { return esc(AF.part(id).short); }).join(" · ") : "Stock") + "</dd></dl>" +
            (r.parts.length ? '<div class="af-actions" style="gap:8px 14px"><a class="af-link" style="font-size:.8rem" href="builder.html#' + r.id + '">Build it ' + I.arrow + '</a><button class="af-link" style="font-size:.8rem" type="button" data-showrun="' + r.id + '">Show on the chart</button></div>' : '<p class="af-p" style="font-size:.85rem">The baseline every package is measured against.</p>') + "</article>";
        }).join("") + "</div>" +
        '<div class="af-gp-panel__head" style="margin-top:8px"><div><p class="af-label" style="margin:0 0 6px">Dyno sheets &amp; results cards</p><p class="af-p">Want the raw numbers? We\'ll send the full data feed from any run on request.</p></div><button class="af-btn af-btn--sm af-btn--dark" type="button" data-book="Dyno data request">Request the dyno data</button></div>';
    } else if (!photos) {
      body = '<div class="af-gp-empty"><p class="af-label" style="margin:0">Photos coming</p><p class="af-p">' + (t.id === "adventures" ? "Out riding with us? Tag " + esc(D.brand.instagram) + " and your shot could be the first one here." : "Photos for this tab are on the way.") + "</p>" + (t.id === "adventures" ? '<span class="af-social">' + AF.socialLinks() + "</span>" : "") + "</div>";
    }
    return '<section class="af-gp-panel" role="tabpanel" id="gp-' + t.id + '" aria-labelledby="gp-tab-' + t.id + '" hidden>' +
      '<div class="af-gp-panel__head"><div style="display:grid;gap:10px"><h2 class="af-h2">' + esc(t.label) + '</h2><p class="af-p">' + esc(t.blurb) + "</p></div>" +
      (t.id === "builds" ? '<button class="af-link" type="button" data-book="Custom build">Start your build ' + I.arrow + "</button>" : t.id === "nitro" ? '<a class="af-link" href="about.html">Our racing story ' + I.arrow + "</a>" : "") + "</div>" +
      body + '<div class="af-gp-grid">' + items.map(function (g, i) { return fig(g, i, i === 0 && g.img && g.photo); }).join("") + "</div></section>";
  }).join("");

  /* lightbox per tab */
  $("#gp-panels").addEventListener("click", function (e) {
    var b = e.target.closest("[data-i]"); if (!b) return;
    var tab = b.closest("[role=tabpanel]").id.replace("gp-", "");
    AF.lightbox(itemsFor(tab), +b.dataset.i);
  });

  /* dyno chart is built the first time the tab opens */
  var dyno = null;
  function ensureDyno() {
    if (dyno) return; dyno = new AF.Dyno($("#gp-dyno-chart"), { toggles: true }); dyno.setRun("full-490", true);
  }
  $("#gp-panels").addEventListener("click", function (e) {
    var b = e.target.closest("[data-showrun]"); if (!b) return;
    ensureDyno(); var id = b.dataset.showrun;
    if (id !== "stock") dyno.setRun(id); $("#gp-dyno-chart").scrollIntoView({ behavior: "smooth", block: "start" });
  });

  /* show / hash routing */
  var tabs = $$(".af-gp-tab");
  function show(id, push) {
    if (!TABS.some(function (t) { return t.id === id; })) id = TABS[0].id;
    tabs.forEach(function (t) { var on = t.dataset.tab === id; t.setAttribute("aria-selected", String(on)); t.tabIndex = on ? 0 : -1; });
    $$(".af-gp-panel").forEach(function (p) { p.hidden = p.id !== "gp-" + id; });
    if (id === "dyno") ensureDyno();
    var sel = $('.af-gp-tab[aria-selected="true"]'), bar = $("#gp-tabs");
    if (sel && bar.scrollWidth > bar.clientWidth) bar.scrollLeft = sel.offsetLeft - (bar.clientWidth - sel.offsetWidth) / 2;
    if (push) history.replaceState(null, "", "#" + id);
  }
  tabs.forEach(function (t, i) {
    t.addEventListener("click", function () { show(t.dataset.tab, true); });
    t.addEventListener("keydown", function (e) {
      var k = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0; if (!k) return;
      e.preventDefault(); var n = tabs[(i + k + tabs.length) % tabs.length]; show(n.dataset.tab, true); n.focus();
    });
  });
  addEventListener("hashchange", function () { show(location.hash.slice(1)); });
  show(location.hash.slice(1));
  AF.reveal();
})();
